import Hokej from './Hokej'

const Futsal = () => <Hokej calculatorType='Futsal' />

export default Futsal
